import { jsx as _jsx } from "react/jsx-runtime";
import { ActionsColumn } from '../table/columns/actions';
import { Remove } from '@otp/icons';
import { FileType } from '../table/columns/file-type';
export const getFileManagerTableConfig = (files, props, { t }) => {
    const tableColumns = [
        {
            name: 'type',
            label: t('file-manager.type', 'Type'),
            options: {
                setCellProps: () => ({
                    style: {
                        width: '1%',
                        whiteSpace: 'nowrap',
                    },
                }),
                customBodyRender: (value) => {
                    return _jsx(FileType, { type: value });
                },
            },
        },
        {
            name: 'title',
            label: t('file-manager.title', 'Name'),
        },
    ];
    if (!props.readonly) {
        tableColumns.push({
            name: 'actions',
            label: ' ',
            options: {
                customBodyRender: (_, meta) => {
                    const file = files[meta.rowIndex];
                    const icons = [];
                    if (!file.readonly) {
                        const deleteButton = {
                            icon: _jsx(Remove, {}),
                            onClick: (e) => {
                                if (e) {
                                    e.stopPropagation();
                                }
                                props.onFileDelete(meta.rowIndex);
                            },
                        };
                        icons.push(deleteButton);
                    }
                    return _jsx(ActionsColumn, { icons: icons, noDefaultAction: true });
                },
            },
        });
    }
    return tableColumns;
};
